import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import { Link } from 'react-router-dom';
import { Mail, ArrowRight, Loader2, CheckCircle, AlertCircle, ChevronLeft } from 'lucide-react';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });
    
    try {
      // Ottimizzazione: URL dinamico basato sull'ambiente attuale (localhost o produzione)
      const redirectUrl = `${window.location.origin}/update-password`;
      
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: redirectUrl,
      });
      
      if (error) throw error;
      
      setMessage({ type: 'success', text: 'Link inviato! Controlla la tua email.' });
    } catch (error) {
      // Gestione errore "Rate limit" (troppe richieste)
      const msg = error.message.includes('Rate limit') 
        ? 'Troppe richieste. Riprova tra qualche minuto.' 
        : error.message;
      setMessage({ type: 'error', text: msg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center p-4 relative overflow-hidden">
      <div className="absolute top-[-10%] right-[-10%] w-[600px] h-[600px] bg-blue-100 rounded-full blur-[120px]"></div>
      
      <div className="bg-white rounded-[2.5rem] shadow-2xl shadow-slate-200 border border-slate-100 w-full max-w-md p-10 relative z-10">
        <Link to="/login" className="inline-flex items-center gap-1 text-slate-500 hover:text-indigo-600 mb-8 transition text-sm font-bold">
            <ChevronLeft size={16} /> Torna al Login
        </Link>
        
        <div className="text-center mb-8">
            <div className="bg-indigo-50 w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4 text-indigo-600">
                <Mail size={32} />
            </div>
            <h2 className="text-2xl font-black text-slate-900">Recupero</h2>
            <p className="text-slate-500 text-sm mt-2 font-medium">Inserisci la email associata all'account.</p>
        </div>

        {message.text && (
            <div className={`p-4 mb-6 rounded-xl flex items-start gap-3 text-sm font-bold border ${message.type === 'error' ? 'bg-red-50 border-red-100 text-red-600' : 'bg-green-50 border-green-100 text-green-600'}`}>
                {message.type === 'error' ? <AlertCircle size={18} className="shrink-0 mt-0.5" /> : <CheckCircle size={18} className="shrink-0 mt-0.5" />} 
                {message.text}
            </div>
        )}

        <form onSubmit={handleReset} className="space-y-5">
            <div className="relative group">
                <Mail className="absolute left-4 top-3.5 h-5 w-5 text-slate-400 group-focus-within:text-indigo-600 transition" />
                <input 
                    type="email" 
                    placeholder="Email" 
                    className="w-full pl-12 pr-4 py-3.5 rounded-2xl bg-slate-50 border-transparent focus:bg-white focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 outline-none transition font-bold text-slate-800 placeholder:text-slate-400" 
                    value={email} 
                    onChange={(e) => setEmail(e.target.value)} 
                    required 
                />
            </div>
            
            <button disabled={loading} className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-4 rounded-2xl transition-all shadow-xl shadow-indigo-600/20 flex justify-center items-center gap-2 hover:-translate-y-1 disabled:opacity-70 disabled:cursor-not-allowed">
                {loading ? <Loader2 className="animate-spin" /> : 'Invia Link'} 
                {!loading && <ArrowRight size={18} />}
            </button>
        </form>
      </div>
    </div>
  );
};
export default ForgotPassword;